module.exports = __webpack_public_path__ + "static/media/area_atuacao.aad96a54.png";